export const gradingColourMixin = {
  methods: {
    gradingColor(value, type = "bg") {
      value = value < 1 ? 1 : value;
      let classes = {};
      switch (value) {
        case 1:
          classes["text"] = "text-grading-value-1";
          classes["bg"] = "bg-grading-value-1";
          classes["border"] = "border-grading-value-1";
          break;
        case 2:
          classes["text"] = "text-grading-value-2";
          classes["bg"] = "bg-grading-value-2";
          classes["border"] = "border-grading-value-2";
          break;
        case 3:
          classes["text"] = "text-grading-value-3";
          classes["bg"] = "bg-grading-value-3";
          classes["border"] = "border-grading-value-3";
          break;
        case 4:
          classes["text"] = "text-grading-value-4";
          classes["bg"] = "bg-grading-value-4";
          classes["border"] = "border-grading-value-4";
          break;
        case 5:
          classes["text"] = "text-grading-value-5";
          classes["bg"] = "bg-grading-value-5";
          classes["border"] = "border-grading-value-5";
          break;
        case 6:
          classes["text"] = "text-grading-value-6";
          classes["bg"] = "bg-grading-value-6";
          classes["border"] = "border-grading-value-6";
          break;
        case 7:
          classes["text"] = "text-grading-value-7";
          classes["bg"] = "bg-grading-value-7";
          classes["border"] = "border-grading-value-7";
          break;
        case 8:
          classes["text"] = "text-grading-value-8";
          classes["bg"] = "bg-grading-value-8";
          classes["border"] = "border-grading-value-8";
          break;
        case 9:
          classes["text"] = "text-grading-value-9";
          classes["bg"] = "bg-grading-value-9";
          classes["border"] = "border-grading-value-9";
          break;
        case 10:
          classes["text"] = "text-grading-value-10";
          classes["bg"] = "bg-grading-value-10";
          classes["border"] = "border-grading-value-10";
          break;
      }
      return classes[type];
    }
  }
};
